// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BecomeMVA_wrapper__rHLDi","title":"BecomeMVA_title__wqGYl","summary":"BecomeMVA_summary__FbFnm"};